module.exports = __webpack_public_path__ + "img/horizontal_7_6_pp1_8019.6239fb7c.png";